/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import cn from 'classnames';
import defaultPhoto from 'assets/img/image-placeholder.jpg';
import Img from 'modules/common/components/Img';

function Requirements({ data }) {
  const tabList = data || [];

  const [requirementTab, setRequirementTab] = useState(0);

  const handleChangeRequirementTab = (location) => () => {
    setRequirementTab(location);
  };

  return (
    <div className="m-3">
      <div className={cn('row mb-3', _.isEmpty(tabList) && 'd-flex')}>
        {!_.isEmpty(tabList) ? (
          <>
            {/* TABS */}
            <div className="col-6">
              <div className="form-wrapper arrow-card">
                {/* {!_.isEmpty(tabList)
                  ? 
                  : ''} */}
                {tabList.map((item, i) => (
                  <div
                    key={item.id}
                    role="presentation"
                    className="arrow-cell p-3 btn-blank"
                    onClick={handleChangeRequirementTab(i)}
                  >
                    <div className="font-weight-bold">
                      {_.get(item, 'attributes.name')}
                    </div>
                    {i === requirementTab ? <div className="arrow" /> : ''}
                  </div>
                ))}
              </div>
            </div>
            {/* IMAGE HOLDER */}
            <div className="col-6">
              <div className="form-wrapper preview-image">
                <React.Fragment>
                  {tabList.map(
                    (
                      item,
                      i // MAP AND CHECK IF ITEM IS EQUAL TO ACTIVE TAB
                    ) =>
                      i === requirementTab ? (
                        <Img
                          key={item.id}
                          src={_.get(item, 'attributes.url')}
                          className="shadow-lg"
                          role="presentation"
                          defaultSrc={defaultPhoto}
                          width="80%"
                          alt=""
                        />
                      ) : (
                        ''
                      )
                  )}
                </React.Fragment>
              </div>
            </div>
          </>
        ) : (
          <div
            className="d-flex justify-content-center w-100"
            style={{ height: '13rem' }}
          >
            <h4 className="">No requirements found</h4>
          </div>
        )}
      </div>
    </div>
  );
}

Requirements.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(Requirements);
